<template>
  <div class="app-trend">
    <div class="label" v-if="label">
      {{ label }}
    </div>
    <TrendChart
      v-if="dataSet.length > 0"
      padding="3"
      @mouse-move="onMouseMove"
      :interactive="true"
      :datasets="[
        {
          data: dataSet,
          smooth: true,
          fill: true,
          showPoints: true
        }
      ]"
    >
    </TrendChart>
  </div>
</template>

<script>
export default {
  mounted() {
    this.dataSet = this.params.value;
  },

  data() {
    return {
      label: null,
      dataSet: []
    };
  },

  methods: {
    onMouseMove(params) {
      if (!params) {
        this.label = null;
        return;
      }

      this.label = params.data[0];
    }
  }
};
</script>

<style lang="scss">
.app-trend {
  height: 100%;
  position: relative;

  .label {
    display: none;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 0.625rem;
    padding: 0.25rem;
    line-height: 1;
    font-weight: normal;
    color: white;
    background-color: rgba($mainColor, 0.75);
    border-radius: 0.3rem;
    pointer-events: none;
  }

  .vtc {
    display: flex;
    flex-wrap: wrap;
    max-width: 100%;

    .stroke {
      stroke-width: 1;
      stroke: $mainColor;
    }

    .fill {
      opacity: 0.2;
      fill: $mainColor;
    }

    .active-line {
      stroke: rgba(0, 0, 0, 0.2);
    }

    .point {
      display: none;
      fill: $mainColor;
      stroke: $mainColor;
    }

    .point.is-active {
      display: block;
    }
  }
}

.app-trend:hover > .label {
  display: inherit;
}
</style>
